// extracted by mini-css-extract-plugin
module.exports = {"root":"OptionButton_root__3tSN-","danger":"OptionButton_danger__-hAnP","primaryInvert":"OptionButton_primaryInvert__3qQg3"};